<template>
  <li
    class="dropdown-menu__item"
    :class="{
      'is-disabled': disabled,
    }"
    :tabindex="disabled ? null : -1"
    :aria-disabled="disabled"
  >
    <slot />
  </li>
</template>
<script>
export default {
  name: 'WootDropdownItem',
  componentName: 'WootDropdownMenu',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.dropdown-menu__item {
  list-style: none;
  margin-bottom: var(--space-micro);

  &:hover {
    color: var(--conversa2-neutral-800-color);
    background-color: var(--conversa2-neutral-50-color);

    &.secondary {
      background: var(--conversa2-neutral-50-color);
      border-color: var(--conversa2-neutral-50-color);
    }
  }

  ::v-deep {
    a,
    .button {
      display: inline-flex;
      white-space: nowrap;
      width: 100%;
      text-align: left;
      color: var(--conversa2-neutral-800-color);

      &:hover {
        background: var(--conversa2-neutral-50-color);
      }

      &:focus {
        background: var(--conversa2-neutral-100-color);
      }

      &.clear {
        color: var(--conversa2-neutral-800-color);

        &:hover {
          color: var(--conversa2-neutral-800-color);
          background-color: var(--conversa2-neutral-50-color);

          &.primary {
            color: var(--conversa2-neutral-800-color);
            background-color: var(--conversa2-neutral-50-color);
          }
        }
      }
    }
  }
}
</style>
